module.exports = __webpack_public_path__ + "img/zxtj_banner.92a269dd.png";